/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { UpdateExternalInfoErrorResponse } from './api.schemas';

import { api } from '../util/http';

export const updatePatientExternalInfo = (patientId: string) => {
  return api<void>({ url: `/api/patient/${patientId}/external-info`, method: 'PUT' });
};

export const getUpdatePatientExternalInfoMutationOptions = <
  TError = UpdateExternalInfoErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updatePatientExternalInfo>>,
    TError,
    { patientId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updatePatientExternalInfo>>,
  TError,
  { patientId: string },
  TContext
> => {
  const mutationKey = ['updatePatientExternalInfo'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updatePatientExternalInfo>>,
    { patientId: string }
  > = (props) => {
    const { patientId } = props ?? {};

    return updatePatientExternalInfo(patientId);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdatePatientExternalInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof updatePatientExternalInfo>>
>;

export type UpdatePatientExternalInfoMutationError = UpdateExternalInfoErrorResponse;

export const useUpdatePatientExternalInfo = <
  TError = UpdateExternalInfoErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updatePatientExternalInfo>>,
      TError,
      { patientId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updatePatientExternalInfo>>,
  TError,
  { patientId: string },
  TContext
> => {
  const mutationOptions = getUpdatePatientExternalInfoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
